import React from "react";
import { Award, TrendingUp, FlaskConical, ShieldCheck } from "lucide-react";

const MarketingValue = () => {
  const values = [
    {
      title: "Superior Genetics",
      desc: "Lineages engineered for maximum meat yield and twinning potential.",
      icon: <Award className="text-[#D4AF37]" size={20} />,
      bg: "bg-amber-50"
    },
    {
      title: "Scientific Rearing",
      desc: "Zero parasite load and consistent gain via stall-fed methodology.",
      icon: <FlaskConical className="text-[#2D5A27]" size={20} />,
      bg: "bg-green-50"
    },
    {
      title: "Proven ROI",
      desc: "Animals reach market weight 30% faster than traditional herds.",
      icon: <TrendingUp className="text-[#2D5A27]" size={20} />,
      bg: "bg-green-50"
    },
    {
      title: "Certified Health",
      desc: "Full vaccination and de-worming records provided for all stock.",
      icon: <ShieldCheck className="text-[#D4AF37]" size={20} />,
      bg: "bg-amber-50"
    },
  ];

  return (
    <section className="py-12 bg-[#FDFCF8] text-[#4B3621]">
      <div className="max-w-7xl mx-auto px-6">
        
        <div className="text-center mb-8">
          <h2 className="text-[9px] font-black uppercase tracking-[0.5em] text-[#D4AF37] mb-2">
            The Competitive Edge
          </h2>
          <h3 className="text-3xl font-black tracking-tighter text-[#4B3621]">
            Why Choose Our Breeding Program?
          </h3>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {values.map((v, i) => (
            <div 
              key={i} 
              className="group p-6 bg-white rounded-2xl border border-gray-100 hover:border-[#D4AF37]/30 hover:shadow-xl hover:shadow-gray-200/50 transition-all duration-300"
            >
              <div className={`w-10 h-10 ${v.bg} rounded-xl flex items-center justify-center mb-4 transition-transform group-hover:scale-110`}>
                {v.icon}
              </div>
              
              <h4 className="text-base font-bold mb-2 text-[#4B3621]">{v.title}</h4>
              <p className="text-gray-500 text-[12px] leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MarketingValue;